import "../../styles/all.css"
import "../../styles/theme.css"
import "./sales.css"
function Sales(){
    return(
        <>
        <div className="sales">
            <div className="program">
                <div className="one">
                    <div className="icon">
                        <i class="fa-brands fa-shopify"></i>

                    </div>
                    <div className="text">
                        <h4>Shopify Ecommerce Store</h4>
                        <h5>Development</h5>
                    </div>

                </div>
                <div className="price">
                    <h4>$1200</h4>
                    <h6>6 projects</h6>
                </div>
            </div>
             <div className="program">
                <div className="one">
                    <div className="icon">
<i class="fa-brands fa-app-store-ios"></i>
                    </div>
                    <div className="text">
                        <h4>Ios Apps Developments</h4>
                        <h5>Development</h5>
                    </div>

                </div>
                <div className="price">
                    <h4>$1450</h4>
                    <h6>3 projects</h6>
                </div>
            </div>
             <div className="program">
                <div className="one">
                    <div className="icon">
<i class="fa-brands fa-figma"></i>                    </div>
                    <div className="text">
                        <h4>Figma Dashbaord Design</h4>
                        <h5>Ui/UX Design</h5>
                    </div>

                </div>
                <div className="price">
                    <h4>$1250</h4>
                    <h6>5 projects</h6>
                </div>
            </div>
            


        </div>
        </>
    )
}
export default Sales